<template>
  <path fill="currentColor" d="M0 24.5h12v12H0v-12zM19 13.5h34v34H19v-34zM60 24.5h12v12H60v-12z" />
</template>
